export enum SessionAnalyticsEnum {
  Sessions = 'sessions',
  AverageSessionDuration = 'average_session_duration',
  Users = 'users',
  NewUsers = 'new_users',
  Hits = 'hits',
  Bounces = 'bounces',
  BounceRate = 'bounce_rate'
}
